const urlMap: Record<
  'production' | 'stage',
  {
    app: string;
    form: string;
    formCms: string;
    www: string;
  }
> = {
  production: {
    app:
      process.env.REACT_APP_APP_SERVICE_HOST ||
      process.env.NEXT_PUBLIC_APP_SERVICE_HOST ||
      'https://app.modusign.co.kr',
    form:
      process.env.REACT_APP_FORM_SERVICE_HOST ||
      process.env.NEXT_PUBLIC_FORM_SERVICE_HOST ||
      'https://form.modusign.co.kr',
    formCms:
      process.env.REACT_APP_FORM_CMS_SERVICE_HOST ||
      process.env.NEXT_PUBLIC_FORM_CMS_SERVICE_HOST ||
      'https://form-cms.modusign.co.kr',
    www:
      process.env.REACT_APP_WWW_SERVICE_HOST ||
      process.env.NEXT_PUBLIC_WWW_SERVICE_HOST ||
      'https://www.modusign.co.kr',
  },
  stage: {
    app:
      process.env.REACT_APP_APP_SERVICE_HOST ||
      process.env.NEXT_PUBLIC_APP_SERVICE_HOST ||
      'https://stage-app.modusign.co.kr',
    form:
      process.env.REACT_APP_FORM_SERVICE_HOST ||
      process.env.NEXT_PUBLIC_FORM_SERVICE_HOST ||
      'https://form-stage.modusign.co.kr',
    formCms:
      process.env.REACT_APP_FORM_CMS_SERVICE_HOST ||
      process.env.NEXT_PUBLIC_FORM_CMS_SERVICE_HOST ||
      'https://form-cms-stage.modusign.co.kr',
    www:
      process.env.REACT_APP_WWW_SERVICE_HOST ||
      process.env.NEXT_PUBLIC_WWW_SERVICE_HOST ||
      'https://stage.modusign.co.kr',
  },
};

const urls = urlMap[process.env.REACT_APP_MODUSIGN_ENV === 'production' ? 'production' : 'stage'];

export const appServiceUrl = urls.app;
export const formServiceUrl = urls.form;
export const formCmsServiceUrl = urls.formCms;
export const wwwServiceUrl = urls.www;
